module.exports = __webpack_public_path__ + "img/efficiency-bills.4c07862.svg";